const aggregations = {
	...require('./average/average'),
	...require('./max/max'),
	...require('./min/min'),
	...require('./sum/sum'),
	...require('./diff/diff')
};

export default aggregations;
